import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingCreationTemplates: {
    id: 'app.creation.templates.loading',
    defaultMessage: 'Loading templates...',
  },
  createNewProductTooltip: {
    id: 'app.creation.createNew.title',
    defaultMessage: 'Create a new product',
  },
  createNewProductDisabledTooltip: {
    id: 'app.creation.createNewDisabled.title',
    defaultMessage: "Something's missing. Please contact us.",
  },
  selectTemplateTitle: {
    id: 'app.creation.selectTemplate.title',
    defaultMessage: 'What template would you like to use?',
  },
  createProductWithTemplate: {
    id: 'app.creation.button.tooltip.companyTemplate',
    defaultMessage: 'Use a company template',
  },
  createProductFullUpload: {
    id: 'app.creation.button.tooltip.fullUpload',
    defaultMessage: 'Upload a complete design',
  },
});
